import { createAction, props, union } from '@ngrx/store';

import { Domain } from './domain.model';

export const Load = createAction('[Engagement/Domain] Load');
export const LoadFail = createAction(
  '[Engagement/Domain] Load fail',
  props<{
    error: string;
  }>()
);
export const LoadSuccess = createAction(
  '[Engagement/Domain] Load success',
  props<{
    domain: Domain;
  }>()
);

export const Change = createAction(
  '[Engagement/Domain] Change',
  props<{
    domain: Domain;
  }>()
);

const actions = union({
  Load,
  LoadFail,
  LoadSuccess,
  Change,
});

export type ActionUnion = typeof actions;
